import {_request, _requestForm} from "./api";

export const list = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'migration', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const migrationData = () => {
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: 'migration', method: 'POST'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};